import {
	Checkbox,
	ExpansionPanel,
	ExpansionPanelDetails,
	FormControl,
	FormControlLabel,
	FormGroup,
	Grid,
	Hidden,
	Paper,
	Radio,
	RadioGroup,
	Step,
	StepButton,
	Stepper,
	Typography,
	WithStyles,
} from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core';
import blueGrey from '@material-ui/core/colors/blueGrey';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from 'src/reducers';
import * as Actions from '../actions/quickModeContens';
import { IQuestionInfo } from '../actions/quickModeContens';
import i18n from '../resources/i18n';
const styles = (theme: Theme) =>
	createStyles({
		checkbox: {
			height: 'auto',
			paddingLeft: '42px',
			whiteSpace: 'pre-wrap',
			wordBreak: 'break-word',
		},
		paper: {
			marginTop: theme.spacing(2),
		},
		question: {
			borderColor: blueGrey[100],
			borderRadius: '1em',
			borderStyle: 'solid',
			marginTop: theme.spacing(1),
			overflowWrap: 'break-word',
			padding: theme.spacing(1),
			wordWrap: 'break-word',
		},
		questionTitle: {
			fontSize: '1rem',
			marginBottom: theme.spacing(2),
		},
		root: {
			padding: theme.spacing(2),
			wordBreak: 'break-word',
		},
		selectAndRadio: {
			height: 'auto',
			whiteSpace: 'pre-wrap',
			width: '100%',
			wordBreak: 'break-word',
		},
		step: {
			position: 'relative',
		},
		table: {
			marginBottom: theme.spacing(2),
			marginTop: theme.spacing(2),
			padding: theme.spacing(3),
		},
		width: {
			width: '100%',
		},
	});

interface IState {
	selectedQuestion: number;
	answers: Map<string, string[]>;
}

class QuickModeTestPreview extends React.Component<IProps, IState> {
	protected preBtnDisabled: boolean;
	protected nextBtnDisabled: boolean;
	public constructor(props: IProps) {
		super(props);
		this.state = {
			answers: new Map<string, string[]>(),
			selectedQuestion: 0,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.props.onRef(this);
	}

	public render() {
		const { test } = this.props;
		if (!test) {
			return <React.Fragment />;
		}
		return (
			<React.Fragment>
				{test.isOneQuestionOneAnswer ? (
					<this.MultiPage />
				) : (
					<this.SinglePage />
				)}
			</React.Fragment>
		);
	}

	/**
	 * 全問一ページ形式の描画
	 */
	protected SinglePage: React.SFC = props => {
		if (!this.props.test) {
			return <React.Fragment />;
		}
		const { classes, test } = this.props;
		const disablePre = this.state.selectedQuestion === 0;
		const disableNex = true;
		this.preBtnDisabled = disablePre;
		this.nextBtnDisabled = disableNex;
		this.props.updateState();

		return (
			<div className={classes.root}>
				<ExpansionPanel defaultExpanded={true}>
					<ExpansionPanelDetails>
						<div style={{ width: '100%' }}>
							{test.questions.map(question => (
								<this.Question
									key={question.seq}
									question={question}
								/>
							))}
						</div>
					</ExpansionPanelDetails>
				</ExpansionPanel>
			</div>
		);
	};

	protected MultiPage: React.SFC = props => {
		if (!this.props.test) {
			return <React.Fragment />;
		}
		const { classes, test } = this.props;
		const question = test.questions[this.state.selectedQuestion];
		const disablePre = this.state.selectedQuestion === 0;
		const disableNex =
			this.state.selectedQuestion === test.questions.length - 1;
		this.preBtnDisabled = disablePre;
		this.nextBtnDisabled = disableNex;
		this.props.updateState();
		return (
			<div className={classes.root}>
				<Grid container={true} spacing={1}>
					<Grid item={true} xs={3}>
						<Paper className={classes.table}>
							<this.Table />
						</Paper>
					</Grid>
					<Grid item={true} xs={9}>
						<this.Question question={question} />
					</Grid>
				</Grid>
			</div>
		);
	};

	/**
	 * 問題部分
	 */
	protected Question: React.SFC<{
		question: Actions.IQuestionInfo;
	}> = props => {
		const { classes } = this.props;
		const { question } = props;

		let answerForm: JSX.Element | null = null;
		switch (question.questionKind) {
			case '1':
			case '2':
				answerForm = <this.AnswerFormRadio question={question} />;
				break;
			case '4':
				answerForm = <this.AnswerFormCheck question={question} />;
				break;
		}

		return (
			<div className={classes.question}>
				<Grid container={true} spacing={3}>
					<Grid item={true} xs={true}>
						<Typography
							variant="h6"
							className={classes.questionTitle}
						>
							<span>
								{i18n.t('QuickModeTestPreview_0000', {
									seq: question.seq,
								})}
							</span>
							<br />
							{question.questionText
								.split('\n')
								.map((item, i) => (
									<React.Fragment key={i}>
										{item}
										<br />
									</React.Fragment>
								))}
						</Typography>
					</Grid>
					<Grid item={true}>
						<Typography>
							{i18n.t('QuickModeTestPreview_0001', {
								score: question.questionScore,
							})}
						</Typography>
					</Grid>
				</Grid>
				{answerForm}
			</div>
		);
	};

	/**
	 * 回答部radio形式
	 */
	protected AnswerFormRadio: React.SFC<{
		question: Actions.IQuestionInfo;
	}> = props => {
		const { question } = props;
		const { test } = this.props;
		const { answers } = this.state;
		let value = '';
		if (answers.get(question.seq.toString())) {
			const str = answers.get(question.seq.toString());
			if (str) {
				value = str[0];
			}
		}
		const margin: React.CSSProperties = {
			marginLeft: '42px',
		};
		return (
			<React.Fragment>
				<Grid container={true} spacing={2} alignItems="flex-start">
					<Grid item={true} xs={true} style={margin}>
						<FormControl
							component="fieldset"
							className={this.props.classes.width}
						>
							<RadioGroup
								name={question.seq.toString()}
								onChange={this.handleChangeRadio(
									question.seq.toString()
								)}
								value={value}
							>
								{question.options.map((option, i) => (
									<FormControlLabel
										key={i}
										className={
											this.props.classes.selectAndRadio
										}
										control={<Radio />}
										label={option.answerText}
										value={option.value}
									/>
								))}
								{test && test.unAnswering && (
									<FormControlLabel
										key={'unselected'}
										className={
											this.props.classes.selectAndRadio
										}
										control={<Radio />}
										label={i18n.t('QuickModeTest_0005')}
										value={''}
									/>
								)}
							</RadioGroup>
						</FormControl>
					</Grid>
				</Grid>
			</React.Fragment>
		);
	};

	protected handleChangeRadio = (questionID: string) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		const answers = this.state.answers;
		answers.set(questionID, [target.value]);
		this.setState({
			answers,
		});
	};

	protected handleChangeCheck = (questionID: string) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		const answers = this.state.answers;
		const str = answers.get(questionID);
		let newAnswers: string[] = [];
		if (str) {
			newAnswers = str.filter(a => a !== target.value);
		}

		if (target.checked) {
			newAnswers.push(target.value);
		}
		answers.set(questionID, newAnswers);
		this.setState({
			answers,
		});
	};

	/**
	 * 回答部check形式
	 */
	protected AnswerFormCheck: React.SFC<{
		question: Actions.IQuestionInfo;
	}> = props => {
		const { question } = props;
		const { classes } = this.props;
		const { answers } = this.state;
		const str = answers.get(question.seq.toString());
		return (
			<FormControl
				component="fieldset"
				className={this.props.classes.width}
			>
				<FormGroup>
					{question.options.map((option, i) => (
						<FormControlLabel
							key={i}
							control={
								<Checkbox
									key={question.seq}
									checked={
										str
											? str.find(a => a === option.value)
												? true
												: false
											: false
									}
								/>
							}
							label={option.answerText}
							value={option.value}
							className={classes.checkbox}
							onChange={this.handleChangeCheck(
								question.seq.toString()
							)}
						/>
					))}
				</FormGroup>
			</FormControl>
		);
	};

	protected Table: React.FunctionComponent<any> = props => {
		const { classes, test } = this.props;
		if (!test) {
			return <React.Fragment />;
		}
		const questions: IQuestionInfo[] = test.questions;
		const { selectedQuestion } = this.state;
		const activeStep = selectedQuestion;
		return (
			<React.Fragment>
				<Stepper
					nonLinear={true}
					orientation="vertical"
					activeStep={activeStep}
				>
					{questions.map((question, i) => {
						return (
							<Step key={question.seq} className={classes.step}>
								<StepButton
									onClick={this.handleSelectQuestion(
										question.seq - 1
									)}
								>
									<Hidden xsDown={true}>
										<Typography>
											{i18n.t(
												'QuickModeTestPreview_0000',
												{
													seq: question.seq,
												}
											)}
										</Typography>
									</Hidden>
								</StepButton>
							</Step>
						);
					})}
				</Stepper>
			</React.Fragment>
		);
	};

	protected handleSelectQuestion = (question: number) => () => {
		this.setState({
			selectedQuestion: question,
		});
	};

	protected handlePrev = () => {
		if (this.preBtnDisabled) {
			this.props.handlePrev();
			return;
		}
		const { selectedQuestion } = this.state;
		if (selectedQuestion > 0) {
			this.setState({
				selectedQuestion: selectedQuestion - 1,
			});
		}
	};

	protected handleNext = () => {
		if (this.nextBtnDisabled) {
			this.props.handleNext();
			return;
		}
		const { selectedQuestion } = this.state;
		const { test } = this.props;
		if (!test) {
			return;
		}
		if (selectedQuestion < test.questions.length - 1) {
			this.setState({
				selectedQuestion: selectedQuestion + 1,
			});
		}
	};
}
const mapStateToProps = (state: IRootState) => ({
	test: state.quickModeContents.test,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	//
});

export interface IQuickModeTestPreviewProps {
	handleNext: () => void;
	handlePrev: () => void;
	onRef: (view: object) => void;
	updateState: () => void;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IQuickModeTestPreviewProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeTestPreview);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModeTestPreview.tsx